<template>
  <div class="detailImgWrap">
    <div class="detailImgWrapCon">
        <el-table
            :border="true"
            :highlight-current-row="false"
            :data="tableData"
            :span-method="spanMethod"
            style="width: 100%"
        >
            <el-table-column
                prop="skcName"
                align="center"
                :label="specifications[0] ? specifications[0].name : ''"
                width="200"
            >
            </el-table-column>
            <el-table-column
                prop="site"
                label="站点"
            >
                <template slot-scope="{ row }">
                    <el-cascader
                        width="300px"
                        v-model="row.site"
                        :props="{multiple:true}"
                        :options="siteList"
                        :show-all-levels="false"
                    >
                    </el-cascader>
                </template> 
            </el-table-column>
            <el-table-column
                prop="img1"
                label="详情图"
            >
                <template slot="header" slot-scope="scope">
                    <div>
                        详情图
                        <el-tooltip class="item" effect="dark" content="要求上传3:4图片，像素大于900px图片为商城最佳展示效果，最多可支持10张" placement="top">
                            <i style="margin-right: 5px;font-size:16px;color:#666;" class="el-icon-question" />
                        </el-tooltip>
                    </div>
                </template>
                <template slot-scope="{ row,$index }">
                    <MutiImgUpload
                        :ref="`detailImg${$index}`"
                        class="mutiImgUpload"
                        v-model="row.imgList" 
                        :mainImgNums="0" 
                        :limitWidth="[0,0]" 
                        :limitHeight="[0,0]" 
                        :limitSize="3 * 1024 * 1024" 
                        :size="200"
                        limitSuffix=".jpg,.jpeg,.png" 
                        :limitNums="10"
                        :aspectRatio="0.75"
                        :aspectRatioText="'3:4'"
                        :isSingle="true"
                        :isCheckImg="true"/>
                </template> 
            </el-table-column>
            <el-table-column
                label="操作"
                width="100"
            >
                <template slot-scope="{ row,$index }">
                    <el-link :underline="false" @click="add(row,$index)">添加</el-link><br/>
                    <el-link :underline="false" type="danger" @click="del(row,$index)">删除</el-link>
                </template> 
            </el-table-column>
        </el-table>
    </div>
  </div>
</template>

<script>
import MutiImgUpload from '@/components/Uploads/MutiImgUpload';

export default {
  components: {
    MutiImgUpload
  },
  props: {
    formData:{
        type: Object,
        default() {
            return {};
        }
    },
    specifications:{
        type: Array,
        default() {
            return [];
        }
    },
    skcDetailImg:{
        type: Array,
        default() {
            return [];
        }
    },
    siteList:{
        type: Array,
        default() {
            return [];
        }
    }
  },
  data() {
    return {
        tableData:[],
        siteOptions:[],
        mergeInfo: {},
        isCheckWhiteImg:false
    };
  },
  computed: {
    shopId() {
      return this.$store.getters.shops_getCategoryPropShopId('shein')
    },
  },
  watch: {
    specifications:{
        handler(val,oldVal) { 
            let obj = val[0];
            let skcList = obj?.values || [];
            let list = [];
            let listMap = {} // 将列表数据转化成map对象
            this.tableData.forEach(i => {
                if(listMap[i.attributeValueId]){
                    listMap[i.attributeValueId].push(i)
                }else{
                    listMap[i.attributeValueId] = [i]
                }
            })
            skcList.forEach(item => {
                let obj = this.skcDetailImg.find(i => (i.attributeId == item.propId && i.attributeValueId == item.propValueId));
                let siteDetailImageInfoList = obj?.siteDetailImageInfoList ? obj.siteDetailImageInfoList : [];
                let _obj = {
                    attributeId:item.propId,
                    attributeValueId:item.propValueId,
                    skcName:item.value,
                }
                if(siteDetailImageInfoList.length){
                    siteDetailImageInfoList.forEach((s,index) => {
                        _obj = {
                            ..._obj,
                            _id:_obj.attributeValueId+'_'+index+1,
                            site:s.siteInfoList.map(i => [i.mainSite,i.site]),
                            siteInfoList:s.siteInfoList,
                            imageInfoList:s.imageInfoList,
                            imgList:s.imageInfoList.map(i => i.imageUrl)
                        }
                    })
                }else{
                    _obj = {
                        ..._obj,
                        _id:_obj.attributeValueId+'_'+1,
                        siteInfoList:[],
                        imageInfoList:[],
                        imgList:[]
                    }
                }
                if(listMap[_obj.attributeValueId]){ // 原来有数据使用原来的数据
                    let _arr = listMap[_obj.attributeValueId];
                    _arr.forEach(i => {
                        list.push(i)
                    })
                }else{ // 没有数据就插入新数据
                    list.push(_obj)
                }
            });
            this.tableData = list;
        },
        deep:true,
        immediate: true,
    },
    tableData:{
        handler(val){
            this.$emit('change',val)
            this.calculateMergeInfo(this.tableData)
        },
        deep:true,
    }
  },
  mounted() {
  },
  methods: {
    add(row,index){
        let arr = row._id.split('_');
        let i = arr[1]+1;
        let obj = {
            _id:row.attributeValueId+'_'+i,
            attributeId:row.attributeId,
            attributeValueId:row.attributeValueId,
            skcName:row.skcName,
            siteInfoList:[],
            imageInfoList:[],
            imgList:[]
        }
        this.tableData.splice(index+1,0,obj);
    },
    del(row,index){
        let listMap = {} // 将列表数据转化成map对象
        this.tableData.forEach(i => {
            if(listMap[i.attributeValueId]){
                listMap[i.attributeValueId].push(i)
            }else{
                listMap[i.attributeValueId] = [i]
            }
        })
        let arr = listMap[row.attributeValueId]; // 当前skc下数据总条数
        if(arr.length > 1){ // skc最后一条数据不能删除
            this.tableData.splice(index,1)
        }
    },  
    // 合并单元格信息计算
    calculateMergeInfo(list) {
      // 初始化合并信息
      this.mergeInfo = {};
      let startIndex = 0;
      let currentValue = '';
      
      list.forEach((row, index) => {
        let curName = row.attributeValueId
        if (index === 0) {
          // 第一个单元格，初始化
          currentValue = curName
          startIndex = index;
        } else if (curName === currentValue) {
          // 与前一个单元格内容相同，继续累加
        } else {
          // 内容不同，记录合并信息，并更新当前值和起始索引
          this.mergeInfo[startIndex] = {
            rowspan: index - startIndex,
            colspan: 1
          };
          currentValue = curName;
          startIndex = index;
        }
      });
      // 处理最后一组相同内容的单元格
      if (startIndex !== list.length - 1) {
        this.mergeInfo[startIndex] = {
          rowspan: list.length - startIndex,
          colspan: 1
        };
      } else {
        // 如果最后一个单元格也是单独一组，也需要记录（rowspan为1）
        this.mergeInfo[startIndex] = {
          rowspan: 1,
          colspan: 1
        };
      }
    },
    spanMethod({ row, columnIndex,column,rowIndex }){
        if(columnIndex === 0){
            // 主销售属性单元格合并
            const mergeInfo = this.mergeInfo[rowIndex];
            if (mergeInfo) {
                return [mergeInfo.rowspan, mergeInfo.colspan];
            } else {
                // 非合并单元格，返回 [0, 0] 表示该单元格不显示
                return [0, 0];
            }
        }
        return [1, 1];
    },
    async method_validImage(){
        for(let i = 0; i < this.tableData.length; i++){
            let ref = `detailImg${i}`;
            let errMsg = await this.$refs[ref].method_validImage();
            let skcName = this.tableData[i].skcName
            if(errMsg){
                return `${skcName}:${errMsg}`
            }
            if(
                (this.tableData[i].imgList && this.tableData[i].imgList.length > 0) &&
                (!this.tableData[i].site || this.tableData[i].site.length == 0)
            ){
                return `${skcName}:站点信息不能为空`
            }
            if(
                (this.tableData[i].site && this.tableData[i].site.length > 0) &&
                (!this.tableData[i].imgList || this.tableData[i].imgList.length == 0)
            ){
                return `${skcName}:详情图不能为空`
            }
        }
    }
  },
};
</script>

<style lang="scss" scoped>
.detailImgWrap{
    ::v-deep .cell {
        padding: 10px;
    }
    // .mutiImgUpload {
    //     ::v-deep .sc-upload{
    //         margin: 0;
    //     }
    // }
}
</style>